import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import utils from '../../animod-shop-ssr/src/utils/index';
import VueMeta from 'vue-meta';

import "@/styles/main.scss";

Vue.config.productionTip = false;

Object.keys(utils).forEach(util => {
    const utilKey = util.startsWith('$') ? util : '$' + util;
    Vue.prototype[utilKey] = utils[util].bind ? utils[util].bind(Vue) : utils[util];
});

Vue.use(VueMeta, {
    keyName: 'head'
});
// import tooltip from '@/directives/tooltip';
// Vue.directive('tooltip', tooltip);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

